import {fetchCourseContent} from "../components/courseContent/courseObjects";

export const getTimeAndScore = (questionHistory, currentCourse) => {
  const courseName = currentCourse || questionHistory.course?.courseName;
  const courseContent = fetchCourseContent(courseName);
  let pointsFromQs = 0;
  let completedQuestionTime = 0;
  let inProgressQuestionTimeStart = null;
  let questionsCorrect = 0;
  let totalQuestions = 0;

  if (!courseContent) {
    return {
      pointsFromQs: 0,
      completedQuestionTime: 0,
      inProgressQuestionTimeStart: null,
      questionsCorrect: 0,
      totalQuestions: 0
    };
  }

  for (const [key, value] of Object.entries(questionHistory)) {
    //conditional that checks if the question is one of the questions in the course content
    if (courseContent.hasOwnProperty(key)) {
      //if there is a start time and an end time then add it to the completed question time
      if (value.startTime && value.endTime) {
        completedQuestionTime += (value.endTime - value.startTime)
        //if there is a start time but no end time then we know a question is in progress
      } else if (value.startTime && !value.endTime) {
        inProgressQuestionTimeStart = value.startTime;
      }
      totalQuestions += 1;
      //conditional to remove the NaNs and only count scores where there was a success
      if (value?.pointsScored > 0 && Array.isArray(value.userActions)) {
        if (value.userActions.includes("success")) {
          pointsFromQs += value?.pointsScored;
          questionsCorrect += 1;
        }
      }
    }
  }
  return ({
    pointsFromQs: pointsFromQs,
    completedQuestionTime: completedQuestionTime,
    inProgressQuestionTimeStart: inProgressQuestionTimeStart,
    questionsCorrect: questionsCorrect,
    totalQuestions: totalQuestions
  });
}; 